module.exports = __webpack_public_path__ + "static/assets/3b953f7d734efbb6bb57f8fed90a0551.gif";